import { UserProfile } from 'src/app/core/models/user';
import { Role } from 'src/app/core/models/user-management/role';
import { AlertDialogModel } from 'src/app/core/models/view-model';
import { Screen } from 'src/app/core/models/user-management/screen';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { RoleScreen } from 'src/app/core/models/user-management/role-screen';
import { ManageRoleModel } from 'src/app/core/models/user-management/manage-roles';
import { AddRoleDialogComponent } from '../add-role-dialog/add-role-dialog.component';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { DeleteDialogComponent } from '../../distributed-ui-components/delete-dialog/delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-manage-roles',
  templateUrl: './manage-roles.component.html',
  styleUrls: ['./manage-roles.component.scss']
})
export class ManageRolesComponent implements OnInit {
  @ViewChild('tableContent', { read: ElementRef })
  public tableContent: any;
  myInnerHeight: any;

  userRoleList: Array<Role>;
  screenList: Array<Screen>;
  roleScreenList: Array<RoleScreen>;
  isLoading = false;
  isLoginUser: UserProfile;
  isLoader = false;
  roleObj: Role;
  deletedRoleId: number;
  alertDialogModel: AlertDialogModel;
  allPermissionRoleId: number;
  secondRoleId: number;

  constructor(private userManagementService: UserManagementService, private sessionService: SessionService, public dialog: MatDialog) {

    this.userRoleList = [];
    this.screenList = [];
    this.roleScreenList = [];
    this.isLoginUser = new UserProfile();
    this.roleObj = new Role();
    this.deletedRoleId = 0;
    this.alertDialogModel = new AlertDialogModel();
    this.allPermissionRoleId = 0;
    this.secondRoleId = 0;
    this.myInnerHeight = window.innerHeight - 150;
  }

  ngOnInit(): void {
    this.fetchUserProfile();
    this.fetchManageRoleData();
  }

  fetchUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((data: UserProfile) => {
      this.isLoginUser = data;
    });
  }

  fetchManageRoleData(): any {
    this.isLoading = true;
    this.userManagementService.getRoleScreenList().subscribe((manageRoles: ManageRoleModel) => {
      this.userRoleList = manageRoles.roleList;
      this.screenList = manageRoles.screenList;
      this.isLoading = false;
      const roleInfo = this.userRoleList.find(a => a.title === 'Compliance Enterprise');
      if (roleInfo) {
        this.allPermissionRoleId = roleInfo.id;
      }
      this.fetchRoleScreens();
    });
  }

  fetchRoleScreens(): any {
    this.userManagementService.getRoleScreens().subscribe((roleScreens: RoleScreen[]) => {
      this.roleScreenList = roleScreens;
    });
  }

  checkRoleScreen(roleId: number, screenId: number, roleScreenArray: Array<RoleScreen>): boolean {
    if (roleScreenArray) {
      return roleScreenArray.find(x => x.roleId === roleId && x.screenId === screenId && x.isActive) != null;
    }
    return false;
  }

  updateRoleScreen(roleId: number, screenId: number, parentId: number, status: boolean): void {
    this.isLoading = true;
    this.userManagementService.updateRoleScreen(roleId, screenId, parentId, status)
      .subscribe(() => {
        this.isLoading = false;
        this.fetchRoleScreens();
      }, () => {
      });
  }

  SaveRoleScreen(): void {
    this.isLoader = true;
    localStorage.removeItem('libraryMenu' + this.isLoginUser.roleId + 'xhr');
    window.location.reload();
  }

  addRole(): void {
    this.roleObj = new Role();
    this.roleObj.heading = 'Add New Role';
    this.openDialog();
  }

  editRole(id: number, displayTitle: string): void {
    this.roleObj.id = id;
    this.roleObj.title = displayTitle;
    this.roleObj.heading = 'Edit Role';
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(AddRoleDialogComponent, {
      width: '450px',
      data: this.roleObj
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.addNewRole(result);
      }
    });
  }

  addNewRole(role: Role): void {
    if (role.title) {
      role.externalUserId = this.isLoginUser.externalUserId;
      role.userName = this.isLoginUser.fullName;
      this.userManagementService.saveNewRole(role).subscribe(() => {
        this.fetchManageRoleData();
        this.fetchRoleScreens();
      }, () => {
      });
    }
  }

  openDeleteDialog(roleId: number): void {
    this.deletedRoleId = roleId;
    this.alertDialogModel.HeadingText = 'Delete Role';
    this.alertDialogModel.BodyText =
      'Associated users will also be deleted with this role, please migrate them to another role if you do not want to remove them.';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Delete Role') {
        this.deleteRole();
      }
    });
  }

  deleteRole(): void {
    this.isLoading = true;
    if (this.deletedRoleId > 0) {
      this.userManagementService.deleteRole(this.deletedRoleId).subscribe(() => {
        this.fetchManageRoleData();
        this.deletedRoleId = 0;
      }, () => {
      });
    }
  }

  isDisabled(roleId: number): boolean {
    if (this.allPermissionRoleId !== this.isLoginUser.roleId) {
      if (this.secondRoleId === this.isLoginUser.roleId) {
        if (this.allPermissionRoleId === roleId) {
          return true;
        } else {
          return false;
        }
      } else {
        if (this.isLoginUser.roleId === roleId) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  public scrollRight(): void {
    this.tableContent.nativeElement.scrollTo({
      left: this.tableContent.nativeElement.scrollLeft + 150,
      behavior: 'smooth'
    });
  }

  public scrollLeft(): void {
    this.tableContent.nativeElement.scrollTo({
      left: this.tableContent.nativeElement.scrollLeft - 150,
      behavior: 'smooth'
    });
  }
}
